/*
 * @Author: 黄昱森
 * @LastEditors: Please set LastEditors
 * @Description:
 */
import UdpForm from './udp-form'
import UdpLabel from './udp-label'
// import UdpTable from './udp-table'
// import UdpTabs from './udp-tabs'
// /** 助手组件 */
import LcSvgIcon from './lc/assistants/lc-svg-icon'
import LcDivider from './lc/assistants/lc-divider'
import LcTableColumnFilter from './lc/assistants/lc-table-column-filter'
import LcNavMenu from './lc/assistants/lc-menu'
import LcPagination from './lc/assistants/lc-pagination'
/** 表单组件 */
import LcInputAmount from './lc/form/lc-input-amount'
import LcFile from './lc/form/lc-file'
import LcExcelExport from './lc/form/lc-excel-export'
import LcExcelImport from './lc/form/lc-excel-import'
import LcTag from './lc/form/lc-tag'
import LcStatus from './lc/form/lc-status'
import LcSlider from './lc/form/lc-slider'
import LcSelectTree from './lc/form/lc-select-tree'
import LcTextarea from './lc/form/lc-textarea'
import LcDatePicker from './lc/form/lc-date-picker'
import LcTimePicker from './lc/form/lc-time-picker'
/** 布局组件 */
import LcBlock from './lc/layout/lc-block'
import LcRower from './lc/layout/lc-rower'
import LcNarrowBroad from './lc/layout/lc-narrow-broad'
import LcThreeColumn from './lc/layout/lc-three-column'
import LcTabNav from './lc/layout/lc-tab-nav'
import LcTabNavPane from './lc/layout/lc-tab-nav-pane'
import LcCard2 from './lc/layout/lc-card2'
import LcSteps from './lc/layout/lc-steps'
import LcStep from './lc/layout/lc-step'
import LcList from './lc/layout/lc-list'
import LcListItem from './lc/layout/lc-list-item'
// import LcEditorTable from './lc/layout/lc-editor-table'
import LcListFilter from './lc/layout/lc-list-filter'
/** 高级组件 */
import LcInputMoney from './lc/advance/lc-input-money'
import LcMagnifier from './lc/advance/lc-magnifier'
import LcPhoneNumber from './lc/advance/lc-phone-number'
import LcInputIcCard from './lc/advance/lc-input-ic-card'
import LcTree from './lc/advance/lc-tree'
import LcImageList from './lc/advance/lc-image-list'
import LcInputIdentityCard from './lc/advance/lc-input-identity-card'


function plugins(Vue) {
  /** UDP组件 */
  Vue.component('UdpForm', UdpForm)
  Vue.component('UdpLabel', UdpLabel)
  // Vue.component('UdpTable', UdpTable)
  // Vue.component('UdpTabs', UdpTabs)

  /** LC组件 */
  /** 助手组件 */
  Vue.component('LcSvgIcon', LcSvgIcon)
  Vue.component('LcNavMenu', LcNavMenu)
  Vue.component('LcDivider', LcDivider)
  Vue.component('LcTableColumnFilter', LcTableColumnFilter)
  Vue.component('LcPagination', LcPagination)
  /** 表单组件 */
  Vue.component('LcInputAmount', LcInputAmount)
  Vue.component('LcFile', LcFile)
  Vue.component('LcExcelExport', LcExcelExport)
  Vue.component('LcExcelImport', LcExcelImport)
  Vue.component('LcTag', LcTag)
  Vue.component('LcStatus', LcStatus)
  Vue.component('LcSlider', LcSlider)
  Vue.component('LcSelectTree', LcSelectTree)
  Vue.component('LcTextarea', LcTextarea)
  Vue.component('LcDatePicker', LcDatePicker)
  Vue.component('LcTimePicker', LcTimePicker)
  /** 布局组件 */
  Vue.component('LcBlock', LcBlock)
  Vue.component('LcRower', LcRower)
  Vue.component('LcNarrowBroad', LcNarrowBroad)
  Vue.component('LcThreeColumn', LcThreeColumn)
  Vue.component('LcTabNav', LcTabNav)
  Vue.component('LcTabNavPane', LcTabNavPane)
  Vue.component('LcCard2', LcCard2)
  Vue.component('LcSteps', LcSteps)
  Vue.component('LcStep', LcStep)
  Vue.component('LcList', LcList)
  Vue.component('LcListItem', LcListItem)
  // Vue.component('LcEditorTable', LcEditorTable)
  Vue.component('LcListFilter', LcListFilter)
  /** 高级组件 */
  Vue.component('LcInputMoney', LcInputMoney)
  Vue.component('LcMagnifier', LcMagnifier)
  Vue.component('LcPhoneNumber', LcPhoneNumber)
  Vue.component('LcInputIcCard', LcInputIcCard)
  Vue.component('LcTree', LcTree)
  Vue.component('LcImageList', LcImageList)
  Vue.component('LcInputIdentityCard', LcInputIdentityCard)
  /** 图表组件 */
  let chartComponents = require.context('./lc/chart/', true, /index\.vue$/)
  chartComponents.keys().forEach(file => {
    const chart = chartComponents(file).default
    Vue.component(chart.name, chart)
  })
}

export default plugins
